import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { BoardViewAgentData } from './fetchBoardViewAgentData.tsx';

export const boardViewAgentDataResource: RouteResource<BoardViewAgentData> =
	createResource<BoardViewAgentData>({
		type: 'BOARD_VIEW_AGENT_DATA',
		getKey: ({ match }) => match.params.projectKey ?? '',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-board-view-agent-data-resource" */ './getBoardViewAgentData.tsx'
			),
		maxAge: 5 * 60 * 1000,
	});
